module.exports = "/packs/media/images/oldercouple_jogbeach-cedc45310d18922b91adf583ea1e3b48.jpg";